import './countdown';

// open the menu, which is collapsed by default on mobile screens, when the user
// taps the btn
const headerMenuBtn = document.getElementById('header-menu-btn');
const headerMenuEl = document.getElementById('header-navigation');
headerMenuBtn.addEventListener('click', () => {
  headerMenuEl.classList.toggle('header-navigation-open');
});

// highlight the current page in the nav bar
const navLinks = document.getElementsByClassName('header-nav-link');

for (const linkItem of navLinks) {
  const linkAnchor = linkItem.getElementsByTagName('a')[0];
  const targetUri = new URL(linkAnchor.href, 'https://cuair.org');

  if (targetUri.toString() === window.location.href) {

    linkItem.classList.add('header-nav-link-active');
    break;
  }
}


window.dataLayer = window.dataLayer || [];

/** For google analytics */
// eslint-disable-next-line no-undef
function gtag() { dataLayer.push(arguments); }
gtag('js', new Date());

gtag('config', 'UA-124645730-1');

// const subteamIdentifier = [
//   'full-team-leads',  'airframe', 'autopilot', 'design-and-operations',
//   'electrical', 'integration-and-testing-operations', 'intelligence', 'structures-payloads',
// ];

$('a.desops').on('click', function () {
  $('html,body').animate({ scrollTop: $('#application-desops').offset().top - 10 },
    'slow');
});

$('a.software').on('click', function () {
  $('html,body').animate({ scrollTop: $('#application-software').offset().top - 10 },
    'slow');
});

$('a.hardware').on('click', function () {
  $('html,body').animate({ scrollTop: $('#application-hardware').offset().top - 10 },
    'slow');
});

$('a.electrical').on('click', function () {
  $('html,body').animate({ scrollTop: $('#application-electrical').offset().top - 10 },
    'slow');
});

$('#application :input').prop('disabled', true);
